<!-- @format -->

<template>
	<disabled-text v-if="disabled && pcProps.showDisabledText" :value="value" />
	<el-input-number
		v-else
		v-model="value"
		:disabled="disabled"
		class="input-number"
		:max="max ?? undefined"
		:min="min ?? undefined"
		controls-position="right"
		@keydown="inputLimit"
	/>
</template>

<script setup lang="ts">
	import { type WidgetConfigType } from '../../types';
	import DisabledText from './disabledText.vue';

	interface Props {
		modelValue: number | string | null;
		pcProps: WidgetConfigType;
		max?: number | null;
		min?: number | null;
		disabled?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: null,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue === 0 ? 0 : props.modelValue ? +props.modelValue : undefined;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const inputLimit = (e) => {
		const key = e.key;
		// 不允许输入'e'、'+'、'-'
		if (key === 'e' || key === '+' || key === '-') {
			e.returnValue = false;
			return false;
		}
		return true;
	};
</script>

<style scoped>
	.input-number {
		width: 100%;
	}
</style>
